/**
 * Surveillance executeSurveillanceCommand — startViewing / stopViewing per device.
 * Each camera playback issues its own request (concurrent WS calls).
 */
const mockStartViewingResponse = () => {
  const clientStreamUrl =
    process.env.REACT_APP_FALCON_URL ||
    (process.env.REACT_APP_WEBSOCKET_URL
      ? (() => {
          try {
            const url = new URL(process.env.REACT_APP_WEBSOCKET_URL);
            return `${url.protocol}//${url.host}/liveview/viewer/ws/mock-session`;
          } catch {
            return "";
          }
        })()
      : "");

  return {
    result: {
      status: "success",
      data: {
        relay: {
          clientStreamUrl,
        },
      },
    },
  };
};

const surveillanceCommandConfig = {
  "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/executeSurveillanceCommand.update": {
    protocol: "ws",
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/devices/:deviceId/executeSurveillanceCommand",
    restful: true,
    method: "update",
    buildParams: null,
    action: null,
    mockHandler: mockStartViewingResponse,
  },
  "/orgs/:orgId/sites/:siteId/devices/:deviceId/executeSurveillanceCommand.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/:deviceId/executeSurveillanceCommand",
    restful: true,
    method: "update",
    buildParams: null,
    action: null,
    mockHandler: mockStartViewingResponse,
  },
};

export default surveillanceCommandConfig;
